<ejs-schedule
    #scheduleObj
    width="100%"
    height="600px"
    cssClass="schedule-builder"
    [eventSettings]="eventSettings"
    [selectedDate]="selectedDate"
    [allowDragAndDrop]="false"
    [views]="['Week']"
    [timeScale]="timeScale"
    [(currentView)]="currentView"
    [quickInfoOnSelectionEnd]="true"
    (popupOpen)="popupOpenHandler($event)"
    (eventRendered)="applyCategoryColor($event)"
>
</ejs-schedule>

<br />

<nz-modal
    [(nzVisible)]="isVisible"
    nzTitle=""
    [nzCentered]="true"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleOk()"
>
    <ng-container *nzModalContent>
        <nz-radio-group *ngIf="!activeSlot?.data?.Id" [(ngModel)]="radioValue">
            <label nz-radio nzValue="AvailabilitySlot">Recurring</label>
            <label nz-radio nzValue="Override">One-Time</label>
        </nz-radio-group>

        <div style="margin-top: 1rem">
            <div *ngIf="radioValue === 'AvailabilitySlot'">
                <p>
                    Repeated every
                    <b>{{ activeSlot.startTime | date : 'EEEE' }}</b>
                </p>
                <div style="display: flex; align-items: center">
                    <div style="margin-right: 10px">from:</div>
                    <nz-time-picker
                        style="width: 100px"
                        nzFormat="h:mm a"
                        nzPlaceHolder="start"
                        [nzSuffixIcon]="null"
                        [nzAllowEmpty]="false"
                        [nzMinuteStep]="5"
                        [(ngModel)]="activeSlot.startTime"
                        [nzUse12Hours]="true"
                    ></nz-time-picker>
                    <div style="margin: 0 10px">to:</div>
                    <nz-time-picker
                        style="width: 100px"
                        nzFormat="h:mm a"
                        nzPlaceHolder="start"
                        [nzSuffixIcon]="null"
                        [nzAllowEmpty]="false"
                        [nzMinuteStep]="5"
                        [(ngModel)]="activeSlot.endTime"
                        [nzUse12Hours]="true"
                    ></nz-time-picker>
                </div>

                <div *ngIf="activeSlot?.data?.Id" style="margin-top: 1rem">
                    <button
                        nz-button
                        nzType="text"
                        nzDanger
                        style="padding-left: 0"
                        nz-popconfirm
                        nzPopconfirmTitle="Are you sure delete this slot?"
                        nzPopconfirmPlacement="right"
                        (nzOnConfirm)="deleteActiveSlot()"
                    >
                        Delete this slot
                    </button>
                </div>
            </div>

            <div
                *ngIf="radioValue === 'Override'"
                style="display: flex; flex-direction: column; gap: 10px"
            >
                <div style="display: flex; align-items: center">
                    <div style="margin-right: 10px">Date:</div>
                    <nz-date-picker
                        [nzFormat]="dateFormat"
                        [nzDisabledDate]="disabledDate"
                        [(ngModel)]="activeSlot.date"
                    ></nz-date-picker>
                </div>

                <div style="display: flex; align-items: center">
                    <div style="margin-right: 10px">Start Time:</div>
                    <nz-time-picker
                        nzFormat="h:mm a"
                        [nzUse12Hours]="true"
                        [nzMinuteStep]="5"
                        [(ngModel)]="activeSlot.startTime"
                    ></nz-time-picker>
                </div>

                <div style="display: flex; align-items: center">
                    <div style="margin-right: 10px">End Time:</div>
                    <nz-time-picker
                        nzFormat="h:mm a"
                        [nzAllowEmpty]="false"
                        [nzUse12Hours]="true"
                        [nzMinuteStep]="5"
                        [(ngModel)]="activeSlot.endTime"
                    ></nz-time-picker>
                </div>

                <label
                    class="is-available-checkbox"
                    nz-checkbox
                    [(ngModel)]="activeSlot.isAvailable"
                >
                    Is Available</label
                >

                <div *ngIf="activeSlot?.data?.Id" style="margin-top: 1rem">
                    <button
                        nz-button
                        nzType="text"
                        nzDanger
                        style="padding-left: 0"
                        nz-popconfirm
                        nzPopconfirmTitle="Are you sure delete this override?"
                        nzPopconfirmPlacement="right"
                        (nzOnConfirm)="deleteActiveOverride()"
                    >
                        Delete this override
                    </button>
                </div>
            </div>

            <div
                *ngIf="showStartTimeAfterEndTimeError"
                style="margin-top: 1rem"
            >
                <nz-alert
                    nzType="error"
                    nzMessage="Start time cannot be after end time"
                ></nz-alert>
            </div>
            
            <div
                *ngIf="showAvailabilityOverlapError"
                style="margin-top: 1rem"
            >
                <nz-alert
                    nzType="error"
                    nzMessage="Availability overlap with this time"
                ></nz-alert>
            </div>
        </div>
    </ng-container>
</nz-modal>
